let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gsVCv")).then(() => parcelRequire('85sEo'));